// DS: C16A
// DS: CR52
/** Displays a whole thread of comments and post box */
import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import { CommentableTypes } from '../Comment/redux/types';
import OffsetTrackingCommentThread from './presets/OffsetTrackingCommentThread';
import SimpleThread from './presets/SimpleThread';
import ModalThread from './presets/ModalThread';
import CardLayoutThread from './presets/CardLayoutThread';

// Note: you cannot have same thread more than once on a page
// you can have multiple different threads

export interface Props {
  commentableTypeId: CommentableTypes;
  commentableItemId: number;
  parentId?: number;
  parentComment?: PapiComment;
  parentCommentRef?: React.RefObject<HTMLElement | null>;
  allowSelfInit?: boolean;
  enableOffsetTracking?: boolean;
  useCardLayout?: boolean;
  /** only display a limited number of comments */
  maxCommentsShown?: number;

  postbox?: 'none' | 'top' | 'topmost' | 'bottom' | 'both';
  statsAndControls?: 'off' | 'title' | 'order' | 'on';

  className?: string;
  isModal?: boolean;
  isInfinite?: boolean;
  isSticky?: boolean;
  extraInHeader?: React.ReactNode;
}

// this component is now just a shell for existing usages - if adding a new
// thread, go directly for one of the presets instead
const CommentThread: React.FC<Props> = ({
  enableOffsetTracking,
  isModal,
  useCardLayout,
  ...props
}) => {
  if (isModal) {
    return <ModalThread {...props} />;
  }

  if (useCardLayout) {
    return <CardLayoutThread {...props} />;
  }

  if (enableOffsetTracking) {
    return <OffsetTrackingCommentThread {...props} />;
  }

  return <SimpleThread {...props} />;
};
CommentThread.displayName = 'CommentThread';

export default CommentThread;
